import sal from 'sal.js';
import 'sal.js/dist/sal.css';

// Init once
const salInstance = sal();

// Track whether SAL is currently enabled
let salEnabled = true;

function switchAnimations() {
  const isMobile = window.innerWidth < 768;

  try {
    // Only do work when the desired state changes
    if (isMobile && salEnabled) {
      salInstance.disable();
      salEnabled = false;
    } else if (!isMobile && !salEnabled) {
      salInstance.enable();
      // Optional: Refresh positions if needed after re-enabling
      salInstance.reset();
      salEnabled = true;
    }
  } catch (e) {
    console.warn('sal.js error:', e);
  }
}

// Run once on load so mobile starts disabled
switchAnimations();

// Update on resize (debounced)
let salResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(salResizeTimer);
  salResizeTimer = setTimeout(switchAnimations, 150);
});

// (Optional) Also handle orientation changes on mobile
window.addEventListener('orientationchange', switchAnimations);